import CircleContainer from './circle-container';
import Container from '@/components/Container';
import { BackButton } from '@/components/ui/back-button';

import LeadershipWheelSkeleton from './loading/LeadershipWheel.skeleton';
import { MessageContainer } from './message-container';
import { useLeadershipWheelStore } from './store/useLeadershipWheelStore';
import { useAuthentication } from '@/hooks/useAuthentication';
import GenericOnboarding from '@/components/generic-onboarding';
import { onChangeOnboardStatus } from '@/services/daily/leadership-wheel.service';
import { ResetLeadershipWheelButton } from './reset-leadership-wheel-button';
import { parseTextWithLinks } from '@/utils/navigation';
import { useState } from 'react';
import { LeadershipWheelFinished } from './leadership-wheel-finished';
import { Calendar } from '../profile/calendar';
import { useLeadershipWheel } from './hooks/useLeadershipWheel';

export default function LeadershipWheelPage() {
  const [showCalendarAndRelatedContent, setShowCalendarAndRelatedContent] = useState(false);
  const { leadershipWheelPage, loading, SubFocusArea, FocusArea } = useLeadershipWheelStore();

  // init data
  // eslint-disable-next-line no-empty-pattern
  const {} = useLeadershipWheel();
  const { authentication, toggleOnboardingStatus } = useAuthentication();

  const renderContent = () => {
    if (!authentication?.user?.onboardLeadershipWheelCompleted) {
      return (
        <GenericOnboarding
          onboarding={leadershipWheelPage?.onboarding}
          onFinish={async () => {
            await onChangeOnboardStatus();
            toggleOnboardingStatus('onboardLeadershipWheelCompleted');
          }}
        />
      );
    }

    return (
      <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
        <div>
          {!loading && !SubFocusArea && (
            <div className="mt-sh-30 flex flex-col items-center justify-center md:mb-8 xl:min-h-[400px]">
              <>
                <div className="mr-sh-30 flex items-center justify-center  ">
                  <MessageContainer />
                </div>
                <div className="flex items-center justify-center md:mt-0 xl:justify-start">
                  <CircleContainer />
                </div>
                <ResetLeadershipWheelButton show={!!FocusArea! && !SubFocusArea} />
              </>
            </div>
          )}
          {!SubFocusArea && (
            <div className="mt-sh-30 flex flex-col items-center  md:mt-0">
              <p className="text-center font-haffer text-sh-14-18">{leadershipWheelPage?.messages?.privacyStatement}</p>
              <p
                key="firstText"
                className="mt-sh-20 text-center text-sh-xxs"
                dangerouslySetInnerHTML={{
                  __html: parseTextWithLinks(
                    leadershipWheelPage?.TraitNotFound?.text || '',
                    leadershipWheelPage?.TraitNotFound?.finalState,
                  ),
                }}
              />
            </div>
          )}

          {SubFocusArea && (
            <LeadershipWheelFinished
              onClickShowLeadershipWheelTrackerButton={() => {
                setShowCalendarAndRelatedContent(true);
              }}
              showCalendarAndRelatedContent={showCalendarAndRelatedContent}
            />
          )}

          {showCalendarAndRelatedContent && (
            <>
              <Calendar isLeadershipWheelPage />
              <ResetLeadershipWheelButton show={!!SubFocusArea} />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-[46rem]">
      <Container className="mt-sh-60">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <BackButton to="/" label="Back" />
        </div>

        {renderContent()}

        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <div>{loading && <LeadershipWheelSkeleton />}</div>
        </div>
      </Container>
    </div>
  );
}
